import CreateNewApplicationButton from './common/components/CreateNewApplicationButton';

const MyApplicationsPanel = () => {
    return (
        <>
            <h2>My Applications</h2>
            <section className='create-new-application'>
                <CreateNewApplicationButton />
            </section>
        </>
    );
};

export default MyApplicationsPanel;
